/** Defaults for /api/location/{id}/care-plan-audit */
export const DEFAULT_CARE_PLAN_AUDIT_PER_PAGE = 20;

export const DEFAULT_CARE_PLAN_AUDIT_FILTERS = {
  date_from: "",
  date_to: "",
  resident_id: "",
  employee_id: "",
  page: 1,
  per_page: DEFAULT_CARE_PLAN_AUDIT_PER_PAGE,
};

/** YYYY-MM-DD for the API, from a Date / moment / string the picker hands back. */
export const toApiDate = (value) => {
  if (!value) return "";
  if (typeof value === "string") {
    const trimmed = value.trim();
    if (/^\d{4}-\d{2}-\d{2}/.test(trimmed)) return trimmed.slice(0, 10);
    const parsed = new Date(trimmed);
    if (Number.isNaN(parsed.getTime())) return "";
    const y = parsed.getFullYear();
    const m = String(parsed.getMonth() + 1).padStart(2, "0");
    const d = String(parsed.getDate()).padStart(2, "0");
    return `${y}-${m}-${d}`;
  }
  if (value instanceof Date && !Number.isNaN(value.getTime())) {
    const y = value.getFullYear();
    const m = String(value.getMonth() + 1).padStart(2, "0");
    const d = String(value.getDate()).padStart(2, "0");
    return `${y}-${m}-${d}`;
  }
  // moment-like
  if (typeof value?.format === "function") {
    return value.format("YYYY-MM-DD");
  }
  return "";
};

export const todayApiDate = () => toApiDate(new Date());

/**
 * Normalize UI filter state into API query fields.
 * @param {{
 *   dateFrom?: Date|string|null,
 *   dateTo?: Date|string|null,
 *   residentId?: string|null,
 *   employeeId?: string|null,
 *   page?: number,
 *   perPage?: number,
 * }} input
 */
export const buildCarePlanAuditFilters = (input = {}) => {
  const page = Number(input.page) > 0 ? Number(input.page) : 1;
  const perPage =
    Number(input.perPage) > 0
      ? Number(input.perPage)
      : DEFAULT_CARE_PLAN_AUDIT_PER_PAGE;

  return {
    date_from: toApiDate(input.dateFrom) || "",
    date_to: toApiDate(input.dateTo) || "",
    resident_id: input.residentId ? String(input.residentId).trim() : "",
    employee_id: input.employeeId ? String(input.employeeId).trim() : "",
    page,
    per_page: perPage,
  };
};

/** Build `?date_from=…&date_to=…` for the care-plan-audit endpoint. */
export const buildCarePlanAuditQuery = (filters = {}) => {
  const params = new URLSearchParams();
  const { date_from, date_to, resident_id, employee_id, page, per_page } = {
    ...DEFAULT_CARE_PLAN_AUDIT_FILTERS,
    ...filters,
  };

  if (date_from) params.set("date_from", date_from);
  if (date_to) params.set("date_to", date_to);
  if (resident_id) params.set("resident_id", resident_id);
  if (employee_id) params.set("employee_id", employee_id);
  if (page) params.set("page", String(page));
  if (per_page) params.set("per_page", String(per_page));

  const qs = params.toString();
  return qs ? `?${qs}` : "";
};
